<input
  #input
  class="toggle"
  type="checkbox"
  [id]="id()"
  [checked]="!collapsed()"
/>
<label
  class="expansion-panel-wrapper"
  tabindex="0"
  [for]="id()"
  (keydown)="onKeyDown($event)"
>
  @if (iconPosition() === 'left') {
    <markant-icon [icon]="'m_chevron-down'" class="icon" />
  }

  <span>{{ title() }}</span>

  @if (iconPosition() === 'right') {
    <markant-icon [icon]="'m_chevron-down'" class="icon align-right" />
  }
</label>
<div class="collapsible-content">
  <div class="content-wrapper">
    <div class="content-inner">
      <ng-content></ng-content>
    </div>
  </div>
</div>
